import { api } from "./api";

export const AssignmentList = async (addUrl) => {
  let url = `assignment/list?${addUrl}`;
  return await api.get(url);
};
export const assignmentAllStaffList = async (addUrl) => {
  let url = `assignment/all/staff/list?${addUrl}`;
  return await api.get(url);
};
export const assignmentStudentList = async (addUrl) => {
  let url = `assignment/student/list?${addUrl}`;
  return await api.get(url);
};

export const addAssignmentApi = async (data) => {
  return await api.post(`/assignment/add`, data);
};

export const assignmentSubmissionShow = async (addUrl) => {
  let url = `assignment/submission/show?${addUrl}`;
  return await api.get(url);
};

export const studentSearchApi = async (addUrl) => {
  return await api.get(`assignment/student/search?${addUrl}`);
};

export const studentAssignmentStatusApi = async (addUrl) => {
  return await api.get(`assignment/student/status?${addUrl}`);
};
